import React from 'react';

/* eslint-disable max-len */
const StoreIcon = _ref => {
  let {
    className,
    title
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M29.6961 10.6565V29.3445H6.20809H2.49609V10.5605",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6961 10.6565V29.3445H6.20809H2.49609V10.5605",
    stroke: "#323254",
    strokeWidth: "1.408",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7041 16.2559H6.91211V26.6239H16.7041V16.2559Z",
    stroke: "#323254",
    strokeWidth: "1.408",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2801 16.2559H20.3201V29.3119H25.2801V16.2559Z",
    stroke: "#323254",
    strokeWidth: "1.408",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.376 23.6804L14.592 22.8164",
    stroke: "#323254",
    strokeWidth: "1.408",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.72803 19.7124L10.944 18.8164",
    stroke: "#323254",
    strokeWidth: "1.408",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0801 22.7842L13.2481 20.5762",
    stroke: "#323254",
    strokeWidth: "1.408",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9759 7.51953V11.4875C30.9759 12.1915 28.7359 13.5675 25.9839 13.5675C23.2319 13.5675 20.9919 12.1915 20.9919 11.4875C20.9919 12.1915 18.7519 13.5675 15.9999 13.5675C13.2479 13.5675 11.0079 12.1915 11.0079 11.4875C11.0079 12.1915 8.76793 13.5675 6.01593 13.5675C3.26393 13.5675 1.02393 12.1915 1.02393 11.4875V7.51953H30.9759Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9841 14.2724C24.0001 14.2724 22.0161 13.6004 20.9921 12.7044C19.9681 13.6004 17.9521 14.2724 16.0001 14.2724C14.0481 14.2724 12.0321 13.6004 11.0081 12.7044C9.98407 13.6004 7.96807 14.2724 6.01607 14.2724C3.20007 14.2724 0.320068 12.8644 0.320068 11.4884V7.52041C0.320068 7.13641 0.640068 6.81641 1.02407 6.81641H30.9761C31.3601 6.81641 31.6801 7.13641 31.6801 7.52041V11.4884C31.6801 12.8644 28.8001 14.2724 25.9841 14.2724ZM21.6961 11.4244C21.9521 11.8404 23.6801 12.8644 25.9841 12.8644C28.2881 12.8644 30.0161 11.8404 30.2721 11.4244V8.22441H21.6961V11.4244ZM11.7121 11.4244C11.9681 11.8404 13.6961 12.8644 16.0001 12.8644C18.3041 12.8644 20.0321 11.8404 20.2881 11.4244V8.22441H11.7121V11.4244ZM1.72807 11.4244C1.98407 11.8404 3.71207 12.8644 6.01607 12.8644C8.32007 12.8644 10.0481 11.8404 10.3041 11.4244V8.22441H1.72807V11.4244Z",
    fill: "#323254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5199 2.65625H5.02393V7.55225H27.5199V2.65625Z",
    fill: "white",
    stroke: "#323254",
    strokeWidth: "1.408",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8479 5.08789H11.4879",
    stroke: "#323254",
    strokeWidth: "1.408",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.24 5.08789H14.88",
    stroke: "#323254",
    strokeWidth: "1.408",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6641 5.08789H18.2721",
    stroke: "#323254",
    strokeWidth: "1.408",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0562 5.08789H21.6642",
    stroke: "#323254",
    strokeWidth: "1.408",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

export { StoreIcon };
